import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import { Config, CognitoIdentityCredentials } from "aws-sdk";

export default class Cognito {
  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito;
      },
    });

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options);
        }
      },
    });
  };

  configure() {
    // ユーザー情報を作る
    this.userPool = new CognitoUserPool({
      UserPoolId: process.env.COGNITO.USER_POOL_ID,
      ClientId: process.env.COGNITO.CLIENT_ID,
    });
    Config.region = process.env.COGNITO.REGION;
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: process.env.COGNITO.IDENTITY_POOL_ID,
    });
    this.options = process.env.COGNITO;
  }

  /**
   * ログイン
   */
  login(username, password) {
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool,
    });
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          resolve(result);
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  /**
   * ログアウト
   */
  logout() {
    this.userPool.getCurrentUser().signOut();
  }

  /**
   * ユーザー名取得
   */
  getUserName() {
    if (!this.userPool.getCurrentUser()) return null;
    return this.userPool.getCurrentUser().getUsername() || null;
  }

  /**
   * ログインしているかの判定
   */
  isAuthenticated() {
    const cognitoUser = this.userPool.getCurrentUser();
    return new Promise((resolve, reject) => {
      if (!cognitoUser) {
        reject(cognitoUser);
      }
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err);
        }
        if (!session.isValid()) {
          reject(session);
        }
        resolve(session);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/cognito/cognito.js